export default {
  bookList: state => state.bookList,
  bookListLoading: state => state.bookListLoading,
  bookInfo: state => state.bookInfo,
  bookInfoLoading: state => state.bookInfoLoading,
  searchParams: state => state.searchParams,
  page: state => state.page
}